/* eslint-disable react/prop-types */
import * as React from 'react';

import { TreeSelect } from 'antd';

import { normalizeToString } from 'utils';

function PrimitiveTreeSelect<T>({
  allowClear = true,
  showSearch = true,
  filterTreeNode = (inputValue, treeNode) =>
    normalizeToString(treeNode.label)
      .toLowerCase()
      .includes(inputValue.toLowerCase()),
  ...props
}: React.ComponentPropsWithoutRef<typeof TreeSelect<T>>) {
  return (
    <TreeSelect<T>
      allowClear={allowClear}
      showSearch={showSearch}
      filterTreeNode={filterTreeNode}
      {...props}
    />
  );
}

export { PrimitiveTreeSelect };
